module.exports = __webpack_public_path__ + "img/img22.6b39ce11.svg";